import store from '@/store/index';

import { includes, filter } from 'lodash';

import { logger } from '@/utils/log';
import { isAutoAddable } from '@/plans/ZOOM_MEETING/common/utils';
import { pageConfig } from '@/common/service/page-config';
import { getPlanTotalLicense } from '@/common/service/validate';
import {
  PlanModelInfo
} from '@/common/constants'

let _isLoadDefaultSelectByQueryCase = false;

export const getIsLoadDefaultSelectByQueryCase = () => {
  return _isLoadDefaultSelectByQueryCase;
};

export const setIsLoadDefaultSelectByQueryCase = (value = false) => {
  logger.info('setIsLoadDefaultSelectByQueryCase: ', value);
  _isLoadDefaultSelectByQueryCase = value;
};

export const addQtyParser = () => {
  let { addQty } = pageConfig;
  if (getIsLoadDefaultSelectByQueryCase() && addQty) {
    const addType = pageConfig?.editConfig?.planType;
    const { boughtPlans, getSelectedPlans } = store.getters;
    const [currentPlan = {}] = getSelectedPlans.filter((plan) => plan.type === addType);
    const dependPlanTypeList = currentPlan.dependBasePlanTypeList;
    const boughtDependPlans = filter(boughtPlans, (p) => includes(dependPlanTypeList, p.type));
    const { plan_code, cartInfo } = currentPlan;

    // limit scope only handle license type
    if (currentPlan.planModel !== PlanModelInfo.license) {
      logger.log('addQtyParser: currentPlan.planModel: ', currentPlan.planModel);
    } else {
      // addQty case in add flow
      addQty = Number(addQty);
      if (isAutoAddable()) {
        store.commit('updateSelectPlan', { plan_code, cartInfo: { ...cartInfo, selected_number: addQty } });
      } else {
        addQty = addQty > currentPlan.max ? currentPlan.max : addQty;
        if (addQty > getPlanTotalLicense(boughtDependPlans)) {
          addQty = getPlanTotalLicense(boughtDependPlans);
        }
        store.commit('updateSelectPlan', { plan_code, cartInfo: { ...cartInfo, selected_number: addQty } });
      }
    }

    setIsLoadDefaultSelectByQueryCase(false);
  } else {
    logger.log('addQtyParser: pass!');
  }
};
